// Success-страница провайдера: <title>Success</title> + window.parent.postMessage({ success: true }).
export const PIN_PROVIDER_SUCCESS_TITLE = 'Success'

export const PIN_PROVIDER_SUCCESS_MESSAGE = 'pin-provider-success'

export function isPinProviderSuccessTitle(title: string | null | undefined): boolean {
  return title?.trim() === PIN_PROVIDER_SUCCESS_TITLE
}

export function isPinProviderSuccessPayload(data: unknown): boolean {
  const payload = parsePinProviderSuccessPayload(data)

  if (!payload || typeof payload !== 'object') return false

  return payload.success === true
}

function parsePinProviderSuccessPayload(data: unknown): { success?: boolean } | null {
  if (typeof data === 'string') {
    if (data === PIN_PROVIDER_SUCCESS_MESSAGE) {
      return { success: true }
    }

    try {
      return parsePinProviderSuccessPayload(JSON.parse(data))
    } catch {
      return null
    }
  }

  if (!data || typeof data !== 'object') return null

  return data as { success?: boolean }
}

// Native WebView: postMessage({ success: true }) не доходит до onMessage — слушаем внутри страницы.
export const PIN_PROVIDER_MESSAGE_LISTENER_SCRIPT = `
(function() {
  var MESSAGE_TYPE = ${JSON.stringify(PIN_PROVIDER_SUCCESS_MESSAGE)};
  var posted = false;

  function notify() {
    if (posted || !window.ReactNativeWebView) return;

    posted = true;
    window.ReactNativeWebView.postMessage(MESSAGE_TYPE);
  }

  window.addEventListener('message', function(event) {
    if (event.data && typeof event.data === 'object' && event.data.success === true) {
      notify();
    }
  });
})();
true;
`

// Native WebView: fallback по title к моменту document end.
export const PIN_PROVIDER_TITLE_WATCH_SCRIPT = `
(function() {
  var SUCCESS_TITLE = ${JSON.stringify(PIN_PROVIDER_SUCCESS_TITLE)};
  var MESSAGE_TYPE = ${JSON.stringify(PIN_PROVIDER_SUCCESS_MESSAGE)};
  var posted = false;

  function notify() {
    if (posted || document.title !== SUCCESS_TITLE || !window.ReactNativeWebView) return;

    posted = true;
    window.ReactNativeWebView.postMessage(MESSAGE_TYPE);
  }

  notify();
})();
true;
`
